// Admin portal — entry point.
//
// Everything wires up inside src/shell/index.ts. main.ts is intentionally
// trivial — locate the root element and hand off.

import { mount } from "./shell/index";

const root = document.getElementById("app");
if (!root) {
  throw new Error("Missing #app root element in index.html");
}

void mount(root);
